import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import * as XLSX from "xlsx";
import CurrencyInput from "react-currency-input-field";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function EmbarquesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS_OC_ACUMULADOS = process.env.REACT_APP_URL_ARTICULOS_OC_ACUMULADOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fechaEmbarque, setFechaEmbarque] = useState(hoy);
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [tipoCambioUSDMXN, setTipoCambioUSDMXN] = useState(1);
  const [tipoCambioCNYUSD, setTipoCambioCNYUSD] = useState(1);

  const [articulosOC, setArticulosOC] = useState([]);
  const [OC, setOC] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [contenedor, setContenedor] = useState("");
  const [numeroInterno, setNumeroInterno] = useState("");
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [proveedores, setProveedores] = useState([]);
  const [proveedorOrden, setProveedorOrden] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [moneda, setMoneda] = useState("");
  const [agrupado, setAgrupado] = useState([]);

  const [conceptosGastos, setConceptosGastos] = useState("");

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      pendEmbarcar: 0,
      piezasPorCaja: 0,
      CBM: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoUSD: 0,
      costoTotal: 0,
      proveedorOrden: "",
      moneda:"",
      OC:""
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
        .get(URL_ARTICULOS_OC_ACUMULADOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CONCEPTOS_GASTOS_EMBARQUES}Fijos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOC = res.data;
        setOC(allOC);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  const saveEmbarqueNuevo = async (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará el Embarque!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then(async (result) => {
    if (
      result.isConfirmed &&
      fechaEmbarque != "" &&
      fechaEstimada != "" &&
      contenedor != "" &&
      numeroInterno != "" &&
      articulosOC != "" &&
      observaciones != ""
    ) {
      setValidaBoton(false);
      toggleProgreso();
     
      let totalArticulos =
        inputFields.length + inputFields.length + conceptosGastos.length;
      let TCosto = inputFields.map((c) => parseFloat(c.costoTotal));
      let TTC = TCosto.reduce((t, total, index) => t + total, 0);
      try {
        await axios
          .post(
            URL_EMBARQUES,
            {
              fechaEmbarque,
              fechaEstimada,
              observaciones,
              contenedor,
              numeroInterno,
              total_cantidad,
              recibido: "No",
              total_costo: parseFloat(TTC).toFixed(2),
              saldo: parseFloat(TTC).toFixed(2),
              creado: user.id,
              proveedores: selectedProveedor,
              total_gasto: 0,
              tipoCambioUSDMXN,
              tipoCambioCNYUSD,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            agrupado.map((b) => {
              axios
                .post(
                  `${URL_NOTAS_CXP}`,
                  {
                    proveedores: selectedProveedor,
                    embarques: data.data._id,
                    total_cantidad: b.cantidad,
                    total_costo: parseFloat(b.costoTotal).toFixed(2),
                    saldo: parseFloat(b.costoTotal).toFixed(2),
                    calidad:"No",
                    fecha:fechaEmbarque
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then((data2) => {
                  inputFields.map((a) => {
                    if (
                      a.articulos != "" &&
                      // a.cantidad != 0 &&
                      a.proveedorOrden == b.proveedorOrden
                    ) {
                      axios
                        .post(
                          `${URL_ARTICULOS_EMBARQUES}`,
                          {
                            articulosOC: a.articulosOrden,
                            articulos: a.articulos,
                            cantidad: a.cantidad,
                            CBM: a.CBM,
                            recibido: 0,
                            pendiente_recibir: a.cantidad,
                            embarques: data.data._id,
                            notasCxP: data2.data._id,
                            costo: a.costo,
                            total_costo: a.costoTotal,
                            proveedores: selectedProveedor,
                            faltante: 0,
                            danado: 0,
                            impuestos: 0,
                            revisarFaltante: 10,
                            revisarDanado: 10,
                            pedirFaltante: 0,
                            pedirDanado: 10,
                            faltanteTotal: 0,
                            danadoTotal: 0,
                            descuentoFaltante: 0,
                            descuentoDanado: 0,
                            descuentoTotal: 0,
                            familias: "NA",
                            sup: "NA",
                            observaciones:"NA",
                            calidad:"No",
                            costoUSD: a.costoUSD,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          totalArticulos = totalArticulos - 1;
                          if (totalArticulos == 0) {
                            axios
                              .post(
                                URL_LOGS,
                                {
                                  tipo: "Crear Embarque",
                                  detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                                  user: user.id,
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer: ${localStorage.getItem(
                                      "app_token"
                                    )}`,
                                  },
                                }
                              )
                              .then(() => {
                                Swal.fire(
                                  "Good job!",
                                  "Creado con exito",
                                  "success"
                                );
                                setTimeout(() => {
                                  window.location.reload();
                                }, 1000);
                              })
                              .catch((error) => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: "Something went wrong!",
                                  footer: `${error.response.data}`,
                                });
                                console.log(error);
                                setValidaBoton(true);
                              });
                          }
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    } else {
                      totalArticulos = totalArticulos - 1;
                      if (totalArticulos == 0) {
                        axios
                          .post(
                            URL_LOGS,
                            {
                              tipo: "Crear Embarque",
                              detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                              user: user.id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then(() => {
                            Swal.fire(
                              "Good job!",
                              "Creado con exito",
                              "success"
                            );
                            setTimeout(() => {
                              window.location.reload();
                            }, 1000);
                          })
                          .catch((error) => {
                            Swal.fire({
                              icon: "error",
                              title: "Oops...",
                              text: "Something went wrong!",
                              footer: `${error.response.data}`,
                            });
                            console.log(error);
                            setValidaBoton(true);
                          });
                      }
                    }
                  });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });

              // Acaba el primer map
            });

            inputFields.map((w) => {
              axios
                .patch(
                  `${URL_ARTICULOS_OC_ACUMULADOS}editEmbarcado/${w.articulosOrden}`,
                  {
                    embarcado: w.cantidad,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Embarque",
                          detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });

            // Acaba el segundo map

            conceptosGastos.map((w) => {
              axios
                .post(
                  URL_GASTOS_EMBARQUES,
                  {
                    conceptosGastosEmbarques: w._id,
                    estimado: w.estimado,
                    real: w.estimado,
                    embarques: data.data._id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Embarque",
                          detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });
          })
          // Catch primer then
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data.message}`,
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false)
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
      setValidaBoton(true);
    }
  })
  };

  function BuscaProveedor(event) {
    const [id, moneda, nombre] = event.target.value.split(",");
    setSelectedProveedor(id)
    setSelectedProveedorNombre(nombre)
    setMoneda(moneda)
    setInputFields(
    [{
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      pendEmbarcar: 0,
      CBM: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoTotal: 0,
      proveedorOrden: selectedProveedor,
      OC:""
    }]
    );
  }

//   function BuscaOC(id, event) {
//     console.log("hola2",event.target.value)
//     const newInputFields = articulosOC.map((a) => {
//       if (event.target.value === a._id) {
//         // if(a.ordenesCompra[0].moneda == "USD"){
//         return{
//         id : uuidv4(),
//         articulosOrden : a._id,
//         articulos : a.articulos[0]._id,
//         cantidad : a.pendiente_embarcar,
//         piezasPorCaja : a.articulos[0].piezasPorCaja,
//         cajas : a.cantidad / a.articulos[0].piezasPorCaja,
//         cantidadOC : a.cantidad,
//         costo : a.articulos[0].costoUSD,
//         costoUSD: a.articulos[0].costoUSD,
//         costoTotal: a.cantidad * a.articulos[0].costoUSD,
//         proveedorOrden : selectedProveedor,
//       }
//     // }else{
//     //   return{
//     //     id : uuidv4(),
//     //     articulosOrden : a._id,
//     //     articulos : a.articulos[0]._id,
//     //     cantidad : a.cantidad,
//     //     piezasPorCaja : a.articulos[0].piezasPorCaja,
//     //     cajas : a.cantidad / a.articulos[0].piezasPorCaja,
//     //     cantidadOC : a.cantidad,
//     //     costo : a.precio,
//     //     costoUSD: a.precio / tipoCambioCNYUSD,
//     //     costoTotal: a.cantidad * a.precio,
//     //     proveedorOrden : selectedProveedor,
//     //     moneda: a.ordenesCompra[0].moneda,
//     //     OC : event.target.value,
//     //   }
//     // }
//     }
//     })
//     .filter(function (el) {
//       return el != null;
//     });
//     setInputFields(newInputFields);

//     let cant = newInputFields.map((c) => parseFloat(c.cantidad));
//     let TC = cant.reduce((t, total, index) => t + total, 0);
//     setTotalCantidad(TC);

//     let agrupado = newInputFields.reduce(function (groups, item) {
//       const val = item["proveedorOrden"];
//       groups[val] = groups[val] || {
//         proveedorOrden: item.proveedorOrden,
//         costoTotal: 0,
//         cantidad: 0,
//       };
//       groups[val].proveedorOrden = item.proveedorOrden;
//       groups[val].costoTotal += item.costoTotal;
//       groups[val].cantidad += item.cantidad;
//       return groups;
//     }, []);
//     let temp = Object.values(agrupado)
//  setAgrupado(temp)
//   }

  function BuscaArticulo(id, event) {
    articulosOC.map((a) => {
      if (a._id == event.target.value) {
      let articulosOrden = a._id;
      let articulos = a.articulos[0]._id;
      let cantidad = a.pendiente_embarcar;
      let pendEmbarcar = a.pendiente_embarcar;
      let piezasPorCaja = a.articulos[0].piezasPorCaja;
      let cajas = a.cantidad / a.articulos[0].piezasPorCaja;
      let cantidadOC = a.cantidad;
      let costo = a.articulos[0].costoUSD;
      let costoUSD= a.articulos[0].costoUSD;
      let costoTotal= a.cantidad * a.articulos[0].costoUSD;
      let proveedorOrden = selectedProveedor;
      handleChangeInputArticulo(id, articulosOrden, articulos, cantidad, pendEmbarcar, piezasPorCaja, cajas, cantidadOC, costo, costoUSD, costoTotal, proveedorOrden);
    }
    });
  }

  const handleChangeInputArticulo = (id, articulosOrden, articulos, cantidad, pendEmbarcar, piezasPorCaja, cajas, cantidadOC, costo, costoUSD, costoTotal, proveedorOrden) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.articulos = articulos;
        i.cantidad = cantidad;
        i.pendEmbarcar = pendEmbarcar;
        i.piezasPorCaja = piezasPorCaja;
        i.cajas = cajas;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoUSD = costoUSD;
        i.costoTotal = costoTotal;
        i.proveedorOrden = proveedorOrden;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    let TC = totalCaptura + 1;

    setTotalCaptura(TC);
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        pendEmbarcar: 0,
        CBM: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoUSD: 0,
        costoTotal: 0,
        proveedorOrden: selectedProveedor,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = values.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  };

  const handleChangeInputCosto = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        i.costoUSD = value;
        let totalParcial = i.cantidad * value
        i.costoTotal = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };


  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  }

  // Verificar cantidad
  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.CBM = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
  };
// console.log("hola", inputFields)
  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(event.target.value <= i.pendEmbarcar || event.target.value == "") {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costoUSD);
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el pendiente embarcar!",
          });
          i[event.target.name] = 0
          i.cajas = 0
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) <= i.pendEmbarcar || event.target.value == "") {
          let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costoUSD);
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el pendiente embarcar!",
          });
          i[event.target.name] = 0
          i.cantidad = 0
        }
       
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Migracion
  //   function importarArchivo(event){
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   let hojas = [];
   
  //   if (name === "file") {
  
  //     let reader = new FileReader();
  //       reader.readAsArrayBuffer(target.files[0]);
  //       reader.onloadend = (e) => {
  //         var data = new Uint8Array(e.target.result);
  //         var workbook = XLSX.read(data, { type: "array" });
  
  //         workbook.SheetNames.forEach(function (sheetName) {
  //           // Here is your object
  //           var XL_row_object = XLSX.utils.sheet_to_json(
  //             workbook.Sheets[sheetName]
  //           );
  //           hojas.push({
  //             data: XL_row_object,
  //             sheetName,
  //           });
  //         });
  
  //         let A1 = hojas[0].data
  
  //         let TC = totalCaptura
  //         A1.map((a)=>{
  //            TC = TC + 1
  //           setTotalCaptura(TC)
  //         inputFields.push({
  //           id: uuidv4(),
  //           articulosOrden: a.articulosOrden,
  //           articulos: a.articulos,
  //           cantidad: a.cantidad,
  //           pendEmbarcar: a.pendiente_embarcar,
  //           piezasPorCaja: 0,
  //           CBM:0,
  //           cajas: 0,
  //           cantidadOC: 0,
  //           costo: 0,
  //           costoUSD: 0,
  //           moneda:"USD",
  //           costoTotal: 0,
  //           proveedorOrden: "689ba2f54efa384c789a04b7",
  //           OC: "67c3e50237778014294883ab"
  //         })
  //         })
  
  //         ActualizaTotales()
  //       }
  //   }
  // }
  // console.log("hola", inputFields)

  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los SKU de los artículos a sus objetos correspondientes
        const articulosMap = {};
        articulosOC.forEach((articulo) => {
          articulosMap[articulo.articulos[0].SKU] = articulo;
        });

        const articulosNoEncontrados = [];
        const articulosCantidadExcedida = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const articulo = articulosMap[a.SKU];
          if (articulo) {
            if (a.cantidad > articulo.pendiente_embarcar) {
              articulosCantidadExcedida.push(
                `${a.SKU} (cantidad: ${a.cantidad}, pendiente: ${articulo.pendiente_embarcar})`
              );
            }
            inputFields.push({
              id: uuidv4(),
              articulosOrden: articulo._id,
              articulos: articulo.articulos[0]._id,
              cantidad: a.cantidad,
              pendEmbarcar: articulo.pendiente_embarcar,
              piezasPorCaja: articulo.articulos[0].piezasPorCaja,
              cajas: a.cantidad / articulo.articulos[0].piezasPorCaja,
              cantidadOC: a.cantidad,
              costo: a.costo,
              costoUSD: a.costo,
              costoTotal: a.costo * a.cantidad,
              CBM: a.CBM,
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.SKU);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes SKU no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        if (articulosCantidadExcedida.length > 0) {
          const mensaje = `Las siguientes líneas exceden la cantidad pendiente por embarcar:\n\n${articulosCantidadExcedida.join(
            "\n"
          )}`;
          Swal.fire({
            title: "Cantidades excedidas",
            text: mensaje,
            icon: "error",
            button: "Revisar",
          });
        }

        ActualizaTotales();
      };
    }
  }
    // console.log("hola", inputFields)
    // console.log("hola2", articulosOC)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.embarques ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Embarque</h3>
          <Form onSubmit={saveEmbarqueNuevo}>
            <Row>
              <Col md={2}>
                <Label>Fecha Embarque</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEmbarque}
                  required
                  onChange={(e) => {
                    setFechaEmbarque(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Selecciona Proveedor</Label>
                <Input
                  name="proveedor"
                  type="select"
                  value={selectedProveedorNombre}
                  // required
                  onChange={(event) => {
                    BuscaProveedor(event);
                  }}
                >
                  <option value="">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option
                          value={`${a._id},${a.moneda},${a.nombre_comercial}`}
                        >
                          {a.nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Proveedor
                </Label>
                <Input
                  type="text"
                  placeholder="proveedor"
                  value={selectedProveedorNombre}
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Moneda
                </Label>
                <Input
                  type="text"
                  placeholder="Moneda"
                  value={moneda}
                  disabled
                />
              </Col>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label># Contenedor</Label>
                <Input
                  type="text"
                  placeholder="contenedor"
                  value={contenedor}
                  required
                  onChange={(e) => {
                    setContenedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Numero Interno</Label>
                <Input
                  type="text"
                  placeholder="Numero Interno"
                  value={numeroInterno}
                  required
                  onChange={(e) => {
                    setNumeroInterno(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Estimada de Arribo</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEstimada}
                  required
                  onChange={(e) => {
                    setFechaEstimada(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Tipo Cambio CNY USD
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioCNYUSD"
                  value={tipoCambioCNYUSD}
                  required
                  onChange={(e) => {
                    setTipoCambioCNYUSD(e.target.value);
                    const newInputFields = inputFields.map((i) => {
                      if (moneda == "CNY") {
                        i.costo = i.costo;
                        i.costoUSD = i.costo / e.target.value;
                        i.costoTotal =
                          parseFloat(i.costo / e.target.value) *
                          parseFloat(i.cantidad);
                      }
                      return i;
                    });
                    setInputFields(newInputFields);
                    ActualizaTotales();
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  TIpo Cambio USD MXN
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioUSDMXN"
                  value={tipoCambioUSDMXN}
                  required
                  onChange={(e) => {
                    setTipoCambioUSDMXN(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Input
                  // required
                  type="file"
                  name="file"
                  id="file"
                  onChange={(event) => importarArchivo(event)}
                />
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>

              <Col md={1}>
                <Label className="mr-sm-2">Pend Embarcar</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Costo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Pzas por Caja</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">CBM</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row
                  style={
                    inputField.cantidad > inputField.pendEmbarcar
                      ? { backgroundColor: "#ed8c8c" }
                      : null
                  }
                >
                  <Col md={4}>
                    <Input
                      // bsSize="sm"
                      name="orden"
                      type="select"
                      value={inputField.articulosOrden}
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {articulosOC
                        .filter(
                          (a) =>
                            a.articulos?.[0]?.proveedores?.[0]?._id ===
                            selectedProveedor
                        )
                        .sort((a, b) =>
                          a.articulos?.[0]?.SKU > b.articulos?.[0]?.SKU ? 1 : -1
                        )
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.articulos?.[0]?.SKU} {a.articulos?.[0]?.nombre}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="pendEmbarcar"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.pendEmbarcar}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="costo"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.costo}
                      className="form-control form-control-md2"
                      style={{ width: "100%", padding: "0.25rem 0.5rem" }}
                      onValueChange={(value, name) =>
                        handleChangeInputCosto(value, name, inputField.id)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cajas}
                      onChange={(event) =>
                        handleChangeInputCantidadCajas(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="piezasPorCaja"
                      type="string"
                      value={inputField.piezasPorCaja}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="CBM"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="CBM"
                      value={inputField.CBM}
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoEmbarques"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default EmbarquesCreate;
